import { removeSetOfNodes } from 'anodum';

const clearTextNodes = (element) => {
  const { ownerDocument: liveDocument } = element;

  const treeWalker = liveDocument.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  const nodesToRemove = [];

  let nodeElement = treeWalker.nextNode();

  while (nodeElement) {
    nodesToRemove.push(nodeElement);
    nodeElement = treeWalker.nextNode();
  }

  removeSetOfNodes(nodesToRemove);
};

export default clearTextNodes;
